/* AKHZ 2026-10-13 (Kalle: "se till att minsta antal ord på en radbrytning är tre", "det gäller hela siten").
   The last three words of every heading, paragraph and list item are tied with no-break spaces, across links and bold
   text, so a text never ends on a line with one or two words. A text of three to five words is kept on one line.
   If tying would push the text wider than its box, it is undone. */
(function () {
  var SEL = 'main h1, main h2, main h3, main h4, main h5, main p, main li, main .h1, main .h2, main .h3, main .h4, footer p, footer li, .sidebar p, .sidebar li';
  function textNodes(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, out = [];
    while ((n = w.nextNode())) { if (!n.parentElement.closest('button, script, style, .akhz-collapse__toggle')) out.push(n); }
    return out;
  }
  function tie(el) {
    if (el.dataset.akhzTie) return;
    el.dataset.akhzTie = '1';
    var words = (el.textContent || '').trim().split(/\s+/).filter(Boolean);
    if (words.length < 3) return;
    var want = words.length <= 5 ? words.length - 1 : 2;
    /* try three words; where the box is too narrow for them, fall back to fewer */
    for (; want > 0; want--) { if (tieN(el, want)) return; }
  }
  function tieN(el, want) {
    var done = 0, saved = [];
    var nodes = textNodes(el), seenText = false;
    for (var j = nodes.length - 1; j >= 0 && done < want; j--) {
      var n = nodes[j], v = n.nodeValue, orig = v;
      for (var i = v.length - 1; i >= 0 && done < want; i--) {
        if (/\S/.test(v[i])) { seenText = true; continue; }
        if (v[i] === ' ' && seenText) { v = v.slice(0, i) + '\u00a0' + v.slice(i + 1); done++; while (i > 0 && v[i - 1] === ' ') i--; }
      }
      if (v !== orig) { saved.push([n, orig]); n.nodeValue = v; }
    }
    if (el.scrollWidth > el.clientWidth + 1) { saved.forEach(function (s) { s[0].nodeValue = s[1]; }); return false; }
    return true;
  }
  /* 2026-10-13: run in idle slices of ~8 ms so the measuring (scrollWidth) never blocks the main thread for long (Lighthouse TBT) */
  var idle = window.requestIdleCallback || function (cb) { return setTimeout(function () { cb({ timeRemaining: function () { return 8; } }); }, 1); };
  function run(root) {
    var list = Array.prototype.slice.call((root && root.querySelectorAll ? root : document).querySelectorAll(SEL)), i = 0;
    (function step(dl) { while (i < list.length && dl.timeRemaining() > 1) tie(list[i++]); if (i < list.length) idle(step); })({ timeRemaining: function () { return 8; } });
  }
  window.akhzTie = function (el) { delete el.dataset.akhzTie; tie(el); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  /* text that arrives later (reviews, filtered product grids, variant updates) */
  var timer; new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 300); })
    .observe(document.body, { childList: true, subtree: true });
})();
